import { useParams } from 'react-router-dom';
import { ToolsDetails } from '../../components/custom';
import { LayoutBase } from '../../layouts';
import { ChatServices } from '../../services/api/chat/chatServices';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { CustomAlert } from '../../components/shared';
import { TopicoInterface, TopicServices } from '../../services/api/chat/topicServices';
import { Typography, Divider, Paper, Box, LinearProgress, IconButton, Chip } from '@mui/material';
import NewChat, { chatData } from '../../components/custom/maintenance/NewChat';
import { formatDate, helpers } from '../../services/helpers/helpers';
import { useAuthContext } from '../../context';
import { Delete, Download } from '@mui/icons-material';

export function ChatPage() {
	const { userData } = useAuthContext();
	const { topico, id } = useParams();
	const [topicoData, setTopicoData] = useState<TopicoInterface>();
	const [dialogChat, setDialogChat] = useState<boolean>(false);
	const [loading, setLoading] = useState<boolean>(false);

	const [alertInfo, setAlertInfo] = useState<{ open: boolean; message: string; severity: 'success' | 'error' | 'warning' | 'info' }>({
		open: false,
		message: '',
		severity: 'success'
	});


	const pagePermissionsString: string | undefined = useMemo(() => {
		return userData?.nivel_acesso?.informacoes?.central;
	}, [userData]);

	const hasActionPermission = useCallback((action: 'add' | 'edit' | 'remove' | 'view'): boolean => {
		if (typeof pagePermissionsString === 'string' && pagePermissionsString !== '') {
			const actions = pagePermissionsString.split(',').map(s => s.trim());
			return actions.includes(action);
		}
		return false;
	}, [pagePermissionsString]);

	// async function FetchChats(uuid: string) {
	// 	try {
	// 		const response = await ChatServices.list(uuid);
	// 		console.log('Chat', response);
	// 	} catch (error) {
	// 		setAlertInfo({ open: true, message: 'Erro ao buscar mensagens !', severity: 'error' });
	// 		console.log('Erro ao buscar mensagens ', error);
	// 	}
	// }

	async function FecthTopico(uuid: string) {
		try {
			const response = await TopicServices.get(uuid);
			if (response instanceof Error) {
				setAlertInfo({ open: true, message: 'Erro ao buscar tópico !', severity: 'error' });
				console.log('Erro ao buscar tópico ', response.message);
			} else {
				setTopicoData(response);

			}
		} catch (error) {
			setAlertInfo({ open: true, message: 'Erro ao buscar tópico !', severity: 'error' });
			console.log('Erro ao buscar tópico ', error);

		}
	}

	async function saveChat(data: chatData) {
		const req = {
			comentario: data.comentario,
			arquivo: data.arquivo,
			id_topico: topico ?? '',
			id_barragem: id ?? '',
		};

		try {
			await ChatServices.create(req);
			setAlertInfo({ open: true, message: 'Tópico criado !', severity: 'success' });
			topico && FecthTopico(topico);
			setDialogChat(false);
		} catch (error) {
			setAlertInfo({ open: true, message: 'Erro ao criar tópico !', severity: 'error' });
			console.log('Erro ao criar tópico ', error);
		}
	}

	async function DeletChat(uuid: string) {
		try {
			await ChatServices.delet(uuid);
			topico && FecthTopico(topico);
			setAlertInfo({ open: true, message: 'Mensagem excluido !', severity: 'success' });
		} catch (error) {
			setAlertInfo({ open: true, message: 'Erro ao buscar Mensagens !', severity: 'error' });
			console.log('Erro ao buscar Mensagens ', error);
		}
	}

	const handleDownload = (fileBase64: string, name: string) => {
		if (!fileBase64) {
			console.log('Não há arquivo para baixar.');
			return;
		}

		let fileType = 'application/octet-stream';
		let fileName = 'download.bin';

		if (fileBase64.startsWith('JVBERi0xL')) {
			fileType = 'application/pdf';
			fileName = name + '.pdf';
		} else if (fileBase64.startsWith('iVBORw0KGgo')) {
			fileType = 'image/png';
			fileName = name + '.png';
			// fileName = 'download.png';
		} else if (fileBase64.startsWith('/9j/')) {
			fileType = 'image/jpeg';
			fileName = name + '.jpeg';
			// fileName = 'download.jpeg';
		}

		const blob = helpers.base64ToBlob(fileBase64, fileType);
		const url = URL.createObjectURL(blob);
		const link = document.createElement('a');
		link.href = url;
		link.setAttribute('download', fileName);

		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
		URL.revokeObjectURL(url);
	};

	useEffect(() => {
		// topico && FetchChats(topico);
		topico && FecthTopico(topico);
	}, [topico]);

	return (
		<LayoutBase
			title='Mensagens do tópico'
			tollBar={
				<ToolsDetails
					showSaveButton={false}
					showDeletButton={false}
					// showNewButton={true}
					onClickNew={() => setDialogChat(true)}
				/>
			}
		>
			<div style={{ padding: 2, display: 'flex', flexDirection: 'column', gap: 1 }}>
				<Typography variant='h5'>Tópico: {topicoData?.titulo && topicoData.titulo}</Typography>
				<Divider />
				{/* <Box sx={{
					border: '1px solid #e0e0e0',
					borderRadius: '8px',
					padding: 2,
				}}>
					<Box sx={{
						marginBottom: 1.5,
						borderBottom: '1px solid #e0e0e0',
						paddingBottom: 1
					}}>
						<Typography><strong>Usuários notificados</strong></Typography>
					</Box>
					<Box sx={{
						display: 'flex',
						gap: 1,
						flexWrap: 'wrap'
					}}>
						{topicoData?.notificados.map((i) => (
							<Chip
								key={i.uuid || i.nome}
								label={i.nome}
								size="medium"
								sx={{
									backgroundColor: '#e0e0e0',
									color: '#666'
								}}
							/>
						))}
					</Box>
				</Box> */}

				{loading && <LinearProgress />}

				{!loading && !topicoData?.comentarios?.length && (
					<Box textAlign='center'>
						<Typography variant='body1'>Nenhum tópico encontrado.</Typography>
					</Box>
				)}

				{topicoData && topicoData?.comentarios.length > 0 &&
					<div style={{ width: '100%', padding: 2, display: 'flex', flexDirection: 'column', gap: 5, marginTop: 2 }}>
						{
							topicoData?.comentarios.map((mensagem) => (
								<Box
									key={mensagem.uuid}
									component={Paper}
									variant='elevation'
									sx={{ padding: 2, border: '1px', borderRadius: 2, display: 'flex', flexDirection: 'row', justifyContent: 'space-between', ':hover': { boxShadow: 5 } }}
								>
									<div>
										<Typography variant='subtitle1'><strong>Comentário: {mensagem.comentario}</strong></Typography>
										<Typography variant='body1'>Criado em: {formatDate(mensagem.data)}</Typography>
										<Typography variant='body1'>Criado por: {mensagem.responsavel}</Typography>
									</div>
									<div style={{ display: 'flex', flexDirection: 'column' }}>
										{mensagem.arquivo && typeof mensagem.arquivo === 'string' &&
											<IconButton title='Baixar' onClick={() => handleDownload(mensagem.arquivo as string, topicoData.titulo)}><Download /></IconButton>
										}
										{userData.uuid == mensagem.id_responsavel && hasActionPermission('remove') &&
											<IconButton title='Deletar' onClick={() => DeletChat(mensagem.uuid)}><Delete /></IconButton>
										}
									</div>
								</Box>
							))
						}
					</div>
				}
			</div>
			<NewChat
				close={() => setDialogChat(false)}
				handleSave={saveChat}
				open={dialogChat}
			/>
			{alertInfo.open &&
				<CustomAlert
					key={alertInfo.message}
					severity={alertInfo.severity}
					message={alertInfo.message}
				/>
			}
		</LayoutBase>
	);
}